<!--
2022-10-17 HHY create
-->
<template>
  <div class="csPage">
    <TopBack title='Complaint And Suggestion'/>
    <div class="controls">
      <div class="row">
        <div class="caption">WhatsApp<i style="color:red;">*</i>:</div>
        <div class="inputs">
          <span>
            +91
          </span>
          <label>
            <input type="number" v-model="whatsApp">
          </label>
        </div>
      </div>
      <div class="row">
        <div class="caption">Email:</div>
        <div class="inputs">
          <label>
            <input type="text" v-model="email">
          </label>
        </div>
      </div>
      <div class="row">
        <div class="caption">Type<i style="color:red;">*</i>:</div>
        <div class="inputs">
          <div class="inputRow">
            <div class="select pointer">
              <div/>
              <div class="input" @click.stop="showSelect = !showSelect">{{selectedVal}}</div>
              <img :src="triangle" :class="{rotate: showSelect}" alt="">
              <div class="selectList" v-show="showSelect">
                <div class="option pointer" v-for="(item, index) in feedbackList" :key="index" @click="select('selectedVal', item.value)">{{item.label}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row2">
        <div class="caption">Details<i style="color:red;">*</i>:</div>
        <div class="inputs">
            <textarea v-model="content"></textarea>
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="SummitComplaint">Summit</div>
      </div>
    </div>

  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import triangle from '@/assets/images/common/triangle.svg'
import {Toast} from 'mint-ui'
import request2 from '@/service2'

export default {
  name: 'Support',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      triangle,
      whatsApp: '',
      email: '',
      content: '',
      feedbackList: [
        {
          label: 'Complaint',
          value: 'Complaint'
        },
        {
          label: 'Suggestion',
          value: 'Suggestion'
        },
        {
          label: 'Others',
          value: 'others'
        }
      ],
      showSelect: false,
      selectedVal: 'Complaint'
    }
  },
  components: {
    TopBack
  },
  methods: {
    select (type, val) {
      this[type] = val // 动态传参，赋值给data中的某个key,如this.selectedVal 2022-10-17 HHY
      this.showSelect = false
    },
    SummitComplaint () {
      if (this.whatsApp === '') {
        Toast(this.$t('lang.complaints.whatsappNotAllowedEmpty'))
        return
      }
      if (this.whatsApp.length !== 10) {
        Toast(this.$t('lang.complaints.lengthMustBeTen'))
        return
      }
      // if (this.email === '') {
      //   Toast(this.$t('lang.complaints.emailNotAllowedEmpty'))
      //   return
      // }
      if (this.content === '') {
        Toast(this.$t('lang.complaints.contentNotAllowedEmpty'))
        return
      }
      if (this.content.length > 300) {
        Toast(this.$t('lang.complaints.contentLenOutOfLimit'))
        return
      }

      const url = '/innovation/complaint/recordcomplaint'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        whatsApp: this.whatsApp,
        email: this.email,
        feedbackType: this.selectedVal,
        details: this.content
      }
      request2('post', url, data).then(res => {
        if (res === -1) {
          Toast(this.$t('lang.complaints.onlySummitOnceWinth24h'))
        }
        if (res === 0) {
          Toast(this.$t('lang.complaints.summitedFailed'))
        }
        if (res === 1) {
          this.whatsApp = ''
          this.email = ''
          this.selectedVal = 'Complain'
          this.content = ''
          Toast(this.$t('lang.complaints.summitSucess'))
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .csPage {
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 56px 0 0 0;
    overflow: scroll;
    .controls{
      height: calc(100% - 86px);
      margin-top:22px;
      .row {
        margin-bottom: 6px;
        display: flex;
        justify-content: flex-start;
        padding:10px 25px;
        font-size: 18px;
        color:#F6D9AA;
        &:last-child {
          margin-bottom: 0;
        }
        .caption{
          width:106px;
          display: flex;
          justify-content:flex-start;
          align-items: center;
        }
        .inputs{
          width:calc(100% - 106px);
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #fff;
          position: relative;
          padding-left:20px;
          span{
            width:32px;
          }
          label {
            flex: 1;
            height: 40px;
            input {
              background: none;
              outline:none;
              border:1px solid rgba(246, 217, 170, 0.5);
              height: 100%;
              width: 100%;
              text-align:left;
              color: #fff;
            }
          }

          .inputRow {
            display: flex;
            height: 40px;
            width: 100%;
            .select, input {
              /*height: 100%;*/
              font-size: 16px;
              line-height: 40px;
              color: #ffffff;
              text-align: center;
              letter-spacing: 0.1em;
              border: 1px solid rgba(246, 217, 170, 0.5);
              &:first-child {
                flex: 1;
              }
              &:last-child {
                flex: 2;
              }
            }
            .select {
              position: relative;
              display: flex;
              align-items: center;
              >div:first-child {
                position: absolute;
                left: 0;
                top: -20px;
              }
              .input {
                /*height: 100%;*/
                width:100%;
              }
              img {
                height: 14px;
                width: 12px;
                margin-right: 10px;
                transition: transform .3s;
                /*position: absolute;*/
                /*top: 50%;*/
                /*transform: translateY(-50%);*/
                /*right: 15px;*/
              }
              .selectList {
                position: absolute;
                left: 0;
                top: 50px;
                padding: 15px 0;
                width: max-content;
                text-align: left;
                background: #202020;
                border: 1px solid rgba(246, 217, 170, 0.5);
                border-radius: 0 0 10px 10px;
                cursor: default;
                z-index: 10;
                .option {
                  padding: 0 15px;
                  line-height: 30px;
                  &:hover {
                    background: #333;
                  }
                }
              }
              .rotate {
                transform: translateY(-50%);
                transform: rotate(90deg);
              }
            }
          }
        }
      }
      .row2{
        margin-bottom: 6px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        padding:10px 25px;
        font-size: 18px;
        color:#F6D9AA;
        .caption{
          width:100%;
          display: flex;
          justify-content:flex-start;
          align-items: center;
          margin-bottom: 10px;
        }
        .inputs{
          width:100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #fff;
          position: relative;
          span{
            width:32px;
          }
          textarea {
            background: none;
            outline:none;
            border:1px solid rgba(246, 217, 170, 0.5);
            height: 180px;
            width: 100%;
            text-align:left;
            color: #fff;
          }
        }
      }
      .btn {
        display: flex;
        justify-content: center;
        .submit {
          background: #F6D9AA;
          color: #000D2E;
          font-size: 22px;
          margin-top: 10px;
          border-radius: 6px;
          height: 50px;
          width: 80%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Support/complaints.vue